import { ChangeDetectionStrategy, Component, HostListener, Injector, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCommentButtonComponent } from '../abstract-comment-button/abstract-comment-button.component';

@Component({
  selector: 'app-resource-related-comment-button',
  templateUrl: './resource-related-comment-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceRelatedCommentButtonComponent extends AbstractCommentButtonComponent implements OnInit {
  @Input()
  shouldOpenOnInit: boolean;

  isPanelOpened$: Observable<boolean>;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.isPanelOpened$ = this.commentPanelManagerService.isPanelOpened();
    super.ngOnInit();

    if (this.shouldOpenOnInit) {
      super.onClick();
    }
  }

  @HostListener('click')
  private onCTAClick(): void {
    this.commentingUserEventsService.trackOpeningSidebarViaCTA(this.resourceType, this.resourceId);
  }
}
